<style scoped>
body {
  overflow: hidden;
  overflow: hidden;
  min-height: 100vh !important;
}
.color-primary {
  color: #1a3665;
}
.btn-primary {
  background-color: #1a3665 !important;
}
input[type="number"] {
  border: 2px solid grey;
  border-radius: 10px !important;
}
.bg-login-half {
  background-image: url("/img/bg-login.jpg");
  background-size: cover;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield !important;
}
:root {
  --input-padding-x: 1.5rem;
  --input-padding-y: 0.75rem;
}

.login,
.image {
  min-height: 100vh;
}

.bg-image {
  background-image: url("/img/bg-login.jpg");
  background-size: cover;
  background-position: center;
}

.login-heading {
  font-weight: 300;
}

/* Fallback for Edge
-------------------------------------------------- */

@supports (-ms-ime-align: auto) {
  .form-label-group > label {
    display: none;
  }
  .form-label-group input::-ms-input-placeholder {
    color: #777;
  }
}
</style>
<template>  
  <div class="container-fluid bg-white">
    <div class="row no-gutter justify-content-center">
      <div class="col-md-8 col-lg-5">
        <div class="login d-flex align-items-center py-5">
          <div class="container">
            <div class="row">
              <div class="col-md-9 col-lg-8 mx-auto">
                <!-- <h3 class="login-heading mb-4">Welcome back!</h3> -->
                <div class="text-center">
                  <h3 class="font-weight-bold">Verifikasi</h3>
                  <p class="text-muted col-8 mx-auto">
                    Masukkan kode verifikasi yang
                    kami kirimkan ke email anda
                  </p>
                </div>
                <form
                  name="form"
                  v-on:submit.prevent="postCheckOtp"
                  action="#"
                  class="my-xl-5 m-md-3"
                >
                  <div class="form-group">
                    <div class="mx-auto">
                      <v-otp-input
                        type="number"
                        ref="otpInput"
                        input-classes="form-control text-center mx-auto px-3 py-4 h4"
                        separator="&nbsp;&nbsp;"
                        :num-inputs="4"
                        :should-auto-focus="true"
                        :is-input-num="true"
                        @on-change="handleOnChange"
                        @on-complete="handleOnComplete"
                        v-model="formData.kodeOtp"
                        required
                      />
                    </div>
                  </div>
                  <h6 class="text-muted mt-2 text-center">Masukkan 4 digit kode verifikasi</h6>
                  <CButton
                    type="submit"
                    color="primary"
                    size="lg"
                    block
                    class="px-4 py-2 font-weight-bold mt-4"
                  >Lanjut</CButton>
                  <router-link to="/pages/login" class="nav-link mt-4 text-center">
                    <p class="font-weight-bold color-primary">Kembali ke Halaman Login</p>
                  </router-link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none col-md-4 col-lg-7 bg-image d-sm-none d-lg-block d-xl-block d-md-none">
        <div class="d-md-flex align-items-center h-100 text-center justify-content-center ml-auto">
          <div class="col-12 d-flex align-items-center h-100 text-white">
            <div class="ml-auto">
              <p class="h1 display-4 font-weight-normal text-right">Selamat Datang di</p>
              <p class="h1 display-4 font-weight-normal text-right">Back Office</p>
              <h5 class="text-right font-weight-bold">Institut Akuntan Publik Indonesia</h5>
              <p class="h4 font-weight-normal mt-3 text-right">Silakan Masukkan Kode Verifikasi.</p>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { cilLockUnlocked } from "@coreui/icons";
import CheckOtpService from "../../services/auth/check-otp.service";

export default {
  data() {
    return {
      formData: {
        email: this.$route.params.email,
        kodeOtp: ""
      },
      kunci: cilLockUnlocked,
      options: ["Option 1", "Option 2", "Option 3"],
      selectOptions: [
        "Option 1",
        "Option 2",
        "Option 3",
        {
          value: ["some value", "another value"],
          label: "Selected option"
        }
      ],
      selectedOption: ["some value", "another value"],

      formCollapsed: true,
      checkboxNames: [
        "Checkboxes",
        "Inline Checkboxes",
        "Checkboxes - custom",
        "Inline Checkboxes - custom"
      ],
      radioNames: [
        "Radios",
        "Inline Radios",
        "Radios - custom",
        "Inline Radios - custom"
      ],
      loading: true
    };
  },
  mounted() {
    if (this.$route.params.email === undefined) {
      this.$router.push("/pages/lupa-password");
    }
  },
  methods: {
    handleOnComplete(value) {
      // comment console console.log("OTP completed: ", value);
      this.formData.kodeOtp = value;
      this.status = true;
    },
    handleOnChange(value) {
      // comment console console.log("OTP changed: ", value);
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
    },

    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Kode Verifikasi Tidak Sesuai!",
        icon: "error",
        showCancelButton: false
      });
    },
    alertSuccess() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Kode Verifikasi Sesuai!"
      });
    },
    postCheckOtp() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      CheckOtpService.postCheckOtp(this.formData)
        .then(response => {
          loader.hide();
          // comment console console.log(response);
          // this.alertSuccess();
          this.$router.push(
            "/pages/password-baru/" +
              this.formData.email +
              "/" +
              this.formData.kodeOtp
          );
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertError();
        });
    }
  }
};
</script>
